import React from 'react'
import Icon from 'core/components/icons/Icon'

const LoadingState = () => {
  return (
    <div className="h-[34rem] grid place-items-center">
      <Icon name="loading" size={42} className="text-primary mb-10" />
    </div>
  )
}
export default LoadingState
